import api from './client';
import type { TalentKategori, Talent } from './types';

/**
 * Talent API
 * Håndterer talent-kategorier og talenter
 */
export const talentAPI = {
  // ===== KATEGORIER =====
  
  getAllKategorier: async (): Promise<{ kategorier: TalentKategori[] }> => {
    const response = await api.get('/talent/kategorier');
    return response.data;
  },

  createKategori: async (data: { 
    navn: string; 
    parentId?: number; 
    beskrivelse?: string 
  }): Promise<{ kategori: TalentKategori }> => {
    const response = await api.post('/talent/kategorier', data);
    return response.data;
  },

  updateKategori: async (id: number, data: { 
    navn?: string; 
    parentId?: number; 
    beskrivelse?: string 
  }): Promise<{ kategori: TalentKategori }> => {
    const response = await api.put(`/talent/kategorier/${id}`, data);
    return response.data;
  },

  deleteKategori: async (id: number): Promise<void> => {
    await api.delete(`/talent/kategorier/${id}`);
  },

  // ===== TALENTER =====
  
  getAll: async (): Promise<{ talenter: Talent[] }> => {
    const response = await api.get('/talent');
    return response.data;
  },

  create: async (data: { 
    navn: string; 
    kategoriId: number; 
    lederId?: number; 
    beskrivelse?: string 
  }): Promise<{ talent: Talent }> => {
    const response = await api.post('/talent', data);
    return response.data;
  },

  update: async (id: number, data: { 
    navn?: string; 
    kategoriId?: number; 
    lederId?: number; 
    beskrivelse?: string 
  }): Promise<{ talent: Talent }> => {
    const response = await api.put(`/talent/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/talent/${id}`);
  },
};

